var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-service-container"
  }, [_c('div', {
    staticClass: "service-item"
  }, [_c('div', {
    staticClass: "item-title media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("service.company2")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("service.contactname") + _vm.$t("service.name21") + ' / ' + _vm.$t("service.phone21") + ' / ' + _vm.$t("service.email21")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50 text_indet"
  }, [_vm._v(_vm._s(_vm.$t("service.name22") + ' / ' + _vm.$t("service.phone22") + ' / ' + _vm.$t("service.email22")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50 text_indet"
  }, [_vm._v(_vm._s(_vm.$t("service.name23") + ' / ' + _vm.$t("service.phone23") + ' / ' + _vm.$t("service.email23")))])]), _vm._v(" "), _c('div', {
    staticClass: "service-item"
  }, [_c('div', {
    staticClass: "item-title media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("service.company1")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("service.contactname") + _vm.$t("service.name11") + ' / ' + _vm.$t("service.phone11") + ' / ' + _vm.$t("service.email11")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50 text_indet"
  }, [_vm._v(_vm._s(_vm.$t("service.name12") + ' / ' + _vm.$t("service.phone12") + ' / ' + _vm.$t("service.email12")))]), _vm._v(" "), _c('span')])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-948ba696","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/components/homeService.vue
// module id = null
// module chunks = 